module.exports = __webpack_public_path__ + "img/meditate-1.46f12d30.svg";